import React from 'react';

const Text = ({title, name, disabled, value, onChange, type='text'}) => (
    <div className={'fieldWrapper'}>
        <label htmlFor={name}>
            {title || name}
        </label>
        <input
            id={name}
            name={name}
            type={type}
            readOnly={disabled}
            defaultValue={value}
            onChange={onChange}
    />
</div>
);


export default Text;
